import { useContext } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../../components";
import { UserContext } from "../../context";
import { redirectToWeblogin } from "../../utils/sessionStorage";

const UnexpectedError = ({ error, resetErrorBoundary }) => {
  const { actions } = useContext(UserContext);
  const user = actions.getPerfil();

  return (
    <>
      {user && <Navbar data={user} />}
      <main className="container">
        <div className="container_menu p-3 rounded">
          <div className="bg-body container p-3 rounded">
            <h1 className="text-center">Ocurrió un error inesperado</h1>
            <h2 className="text-center text-secondary fs-6 fw-medium">
              Por favor, intentá de nuevo es unos instantes. Si el error persiste, comunicarse con
              soporte: desarrolladores@muninqn.gov.ar
            </h2>

            {(actions.hasRole("admin") ||
              actions.hasRole("admin.app") ||
              actions.hasRole("notificador")) && (
              <div className="alert alert-danger mt-4" role="alert">
                <pre className="mb-0">{error.message}</pre>
              </div>
            )}

            <div className="my-4 d-flex justify-content-center gap-2">
              {/* si el usuario no está loggeado, mostramos solamente el boton para volver a MMD  */}
              {!user && (
                <button
                  className="btn btn-primary btn-lg d-flex gap-2 justify-content-center"
                  onClick={() => redirectToWeblogin}
                >
                  <span>Volver a Mi Muni Digital</span>
                </button>
              )}

              {/*  si el usuario está loggeado, mostramos botones para volver al menú principal y al paso anterior de donde falló la app */}
              {user && (
                <div className="d-flex gap-2">
                  <Link className="btn btn-secondary d-flex gap-2 justify-content-center" to={"/"}>
                    <span>Ir al menú</span>
                  </Link>
                  <button
                    className="btn btn-primary d-flex gap-2 justify-content-center"
                    onClick={() => resetErrorBoundary()}
                  >
                    <span>Intentar de nuevo</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default UnexpectedError;
